import { render, staticRenderFns } from "./SingleChipDisplay.vue?vue&type=template&id=aa941768&scoped=true"
import script from "./SingleChipDisplay.vue?vue&type=script&lang=js"
export * from "./SingleChipDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa941768",
  null
  
)

export default component.exports